import React, { useState } from "react";
import { Col, Table, Button } from "react-bootstrap";
import { API_URL } from "../config";
import * as XLSX from "xlsx";

function Users({ regularUsers, fetchUsers }) {
  const [searchValue, setSearchValue] = useState("");

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const deleteUser = (userId) => {
    const accessToken = localStorage.getItem("accessToken");

    // Send a DELETE request to the API to delete the user
    fetch(`${API_URL}/api/regular/${userId}/delete/`, {
      method: "DELETE",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          // Fetch the updated user list
          fetchUsers();
        } else {
          console.error("Failed to delete user:", response.status);
        }
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
      });
  };

  const filteredUsers = regularUsers.filter(
    (user) =>
      user.first_name.toLowerCase().includes(searchValue.toLowerCase()) ||
      user.last_name.toLowerCase().includes(searchValue.toLowerCase())
  );

  const exportToExcel = () => {
    // Create a new array of users including formatted posts_stats and role
    const usersToExport = filteredUsers.map(
      ({ id, is_active, type, posts_stats, role, username, ...rest }) => {
        // Extract counts for each stat type
        const umrlicaCount =
          posts_stats?.find((stat) => stat.type === "umrlica")?.count || 0;
        const poslednjiPozdravCount =
          posts_stats?.find((stat) => stat.type === "poslednji_pozdrav")
            ?.count || 0;
        const pomenCount =
          posts_stats?.find((stat) => stat.type === "pomen")?.count || 0;

        return {
          ...rest,
          umrlica: umrlicaCount, // Add umrlica count
          poslednji_pozdrav: poslednjiPozdravCount, // Add poslednji pozdrav count
          pomen: pomenCount, // Add pomen count
          role, // Add user role
        };
      }
    );

    // Translate column names to Serbian
    const translatedUsers = usersToExport.map((user) => ({
      Ime: user.first_name,
      Prezime: user.last_name,
      Email: user.email,
      "Poslednji login": user.last_login,
      "Datum registracije": user.date_joined,
      "Ukupno umrlica": user.umrlica,
      "Ukupno poslednjih pozdrava": user.poslednji_pozdrav,
      "Ukupno poslednjih pomena": user.pomen,
    }));

    const ws = XLSX.utils.json_to_sheet(translatedUsers);

    // Set column widths for better readability
    const columnWidths = [
      { wch: 15 }, // Ime
      { wch: 15 }, // Prezime
      { wch: 25 }, // Email
      { wch: 20 }, // Poslednji login
      { wch: 20 }, // Datum registracije
      { wch: 20 }, // Ukupno umrlica
      { wch: 30 }, // Ukupno poslednjih pozdrava
      { wch: 30 }, // Ukupno poslednjih pomena
      { wch: 15 }, // Uloga
    ];
    ws["!cols"] = columnWidths; // Apply column widths

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Korisnici");
    XLSX.writeFile(wb, "Korisnici.xlsx");
  };

  return (
    <Col style={{ paddingTop: "20px", width: "100%", height: "100%" }} lg={6}>
      <div style={{ overflowY: "auto", maxHeight: "400px" }}>
        <p>Ukupan broj korisnika: {filteredUsers.length}</p>
        <input
          style={{
            borderRadius: "8px",
            backgroundColor: "black",
            color: "white",
            marginBottom: "10px",
          }}
          type="text"
          value={searchValue}
          onChange={handleSearchChange}
          placeholder="Pretraži korisnike..."
        />
        <Button
          onClick={exportToExcel}
          style={{ marginBottom: "10px", float: "right" }}
        >
          Preuzmi excel
        </Button>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th>#</th>
              <th>Korisnici</th>
              <th>Poslednji login</th>
              <th>Datum registracije</th>
              <th>Email</th>
              <th>Ukupno umrlica</th>
              <th>Ukupno poslednjih pozdrava</th>
              <th>Ukupno poslednjih pomena</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.map((user, index) => (
              <tr key={user.id}>
                <td style={{ width: "100px" }}>{index + 1}</td>
                <td>
                  {user.first_name} {user.last_name}
                  <button
                    style={{
                      backgroundColor: "white",
                      opacity: "0.5",
                      padding: "2px",
                      border: "1px solid white",
                      float: "right",
                      marginRight: "10px",
                      borderRadius: "8px",
                    }}
                    onClick={() => deleteUser(user.id)}
                  >
                    <img
                      src={require("../assets/user-x-solid-24.png")}
                      alt="Delete"
                    />
                  </button>
                </td>
                <td>
                  {user.last_login
                    ? new Date(user.last_login).toLocaleString()
                    : "/"}
                </td>
                <td>{new Date(user.date_joined).toLocaleDateString()}</td>
                <td>{user.email}</td>
                <td>
                  {user.posts_stats?.find((stat) => stat.type === "umrlica")
                    ?.count || 0}
                </td>
                <td>
                  {user.posts_stats?.find(
                    (stat) => stat.type === "poslednji_pozdrav"
                  )?.count || 0}
                </td>
                <td>
                  {user.posts_stats?.find((stat) => stat.type === "pomen")
                    ?.count || 0}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Col>
  );
}

export default Users;
